import { Ability, defineAbilityFor } from '../services/abilityService';
import { useMemo } from 'react';
import { useUserAccess } from './useUserAccess';

interface UserAccess {
  teamAbility: Ability;
  personalAbility: Ability;
  currentAbility: Ability;
}

export const useAbility = (): UserAccess => {
  const { personalAccount, currentAccount, currentTeamAccount } =
    useUserAccess();

  const teamAbility = useMemo(() => {
    return defineAbilityFor(currentTeamAccount);
  }, [currentTeamAccount]);

  const currentAbility = useMemo(() => {
    return defineAbilityFor(currentAccount);
  }, [currentAccount]);

  const personalAbility = useMemo(() => {
    return defineAbilityFor(personalAccount);
  }, [personalAccount]);

  return {
    teamAbility,
    currentAbility,
    personalAbility,
  };
};
